import { Week, OperatingTime } from '~/types/common';

export enum FetchingDataStatus {
  INIT = 'INIT',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum FirebaseDataStatus {
  INIT = 'FIREBASE_DATA_INIT',
  EXIST = 'FIREBASE_DATA_EXIST',
  NOT_EXIST = 'FIREBASE_DATA_NOT_EXIST',
}

export const weekLabel = [
  {
    value: Week.SUN,
    label: '日',
  },
  {
    value: Week.MON,
    label: '一',
  },
  {
    value: Week.TUE,
    label: '二',
  },
  {
    value: Week.WED,
    label: '三',
  },
  {
    value: Week.THU,
    label: '四',
  },
  {
    value: Week.FRI,
    label: '五',
  },
  {
    value: Week.SAT,
    label: '六',
  },
];

export const monthLabel = [
  '一',
  '二',
  '三',
  '四',
  '五',
  '六',
  '七',
  '八',
  '九',
  '十',
  '十一',
  '十二',
];

export const emptyOperatingTime: OperatingTime = {
  [Week.FRI]: [],
  [Week.MON]: [],
  [Week.SAT]: [],
  [Week.SUN]: [],
  [Week.THU]: [],
  [Week.TUE]: [],
  [Week.WED]: [],
};

export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
